export default __webpack_public_path__ + "static/icon-1-4-4c1794775cfb9f1293ea611657df63e0.png";